import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const DueDateUpdateModalUI = ({ context, messageList, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick
}) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_change_due_date'
    buttonMessageKey='c_update'
    cancelMessageKey='c_cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
  </ModalFormUI>

export default DueDateUpdateModalUI
